import partition from 'lodash.partition';
import unset from 'lodash.unset';

export const supportingInfoFhirPath = `(
  contained.where(
    id = %context.supportingInfo.where(
      extension.where(
        url = 'http://healthit.medflowapp/fhir/StructureDefinition/is-active-substitution'
        and valueBoolean = true
      )
    ).first().reference.replace('#','')
  ) | contained.where(id = %context.supportingInfo.first().reference.replace('#',''))
)`;

export function setMedicamentoFromConcentracoes(
  medicationRequest: fhir4.MedicationRequest,
  supportInfoId: string,
  value?: string,
): fhir4.MedicationRequest {
  const [containedActive, containedInative] = partition(
    medicationRequest.contained as fhir4.MedicationRequest[],
    item => item.id === supportInfoId,
  );

  if (containedActive.length > 0) {
    unset(containedActive, '[0].substitution');
    const { dosageInstruction } = containedActive[0];

    if (dosageInstruction) {
      const [dosage = {}] = dosageInstruction;

      return {
        ...medicationRequest,
        contained: [
          ...containedInative,
          {
            ...containedActive[0],
            dosageInstruction: [
              {
                ...dosage,
                ...(value && { text: value }),
              },
            ],
          },
        ],
      };
    }

    return {
      ...medicationRequest,
      contained: [
        ...containedInative,
        {
          ...containedActive[0],
          ...(value && {
            dosageInstruction: [
              {
                text: value,
              },
            ],
          }),
        },
      ],
    };
  }

  return {
    ...medicationRequest,
  };
}
